import React from 'react';
import ReactToPrint from 'react-to-print';

class Printer extends React.Component {
  render() {
    const { children } = this.props;
    return (
      <>
        <ReactToPrint
          trigger={() => (
            <button
              type="button"
              id="printTriggerButton"
              className="btn--icon btn--print"
              alt="Open print modal"
            />
          )}
          content={() => this.componentRef}
        />
        <div ref={el => { this.componentRef = el; }}>{children}</div>
      </>
    );
  }
}

export default Printer;
